import { GridColumnHeaderParams } from "@mui/x-data-grid-pro";

import { AllWasteTypesFilter } from "../../../../components/TableFilters/AllWasteTypesFilter";
import { BooleanFilter } from "../../../../components/TableFilters/BooleanFilter";
import { DateTimeFilter } from "../../../../components/TableFilters/DateTimeFilter";
import { NumberFilter } from "../../../../components/TableFilters/NumberFilter";
import { TextFilter } from "../../../../components/TableFilters/TextFilter";
import { TableHeaderCell } from "../../../../components/TableHeaderCell";
import {
  removeCollectionYardsVisitsDetailFilter,
  setCollectionYardsVisitsDetailFilter,
  setCollectionYardsVisitsDetailOrdering,
} from "../../../../reducers/collectionYardsVisitsDetailReducer";
import {
  getCollectionYardsVisitsDetailFilterIsActiveCached,
  getCollectionYardsVisitsDetailFilterValueCached,
  getCollectionYardsVisitsDetailOrderingValue,
} from "../../../../selectors/collectionYardsVisitsDetail";
import { ColumnType } from "../collectionYardsVisitsDetailTableColumnTypes";

const TABLE_NAME = "collectionYardsVisits";

interface IHeaderCellProps {
  params: GridColumnHeaderParams;
}

const selectFilters = (type: string) => {
  switch (type) {
    case ColumnType.created:
      return (
        <DateTimeFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getCollectionYardsVisitsDetailFilterValueCached}
          filterUpdateAction={setCollectionYardsVisitsDetailFilter}
        />
      );
    case ColumnType.collectionYardName:
      return (
        <TextFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getCollectionYardsVisitsDetailFilterValueCached}
          filterUpdateAction={setCollectionYardsVisitsDetailFilter}
        />
      );
    case ColumnType.wasteTypes:
      return (
        <AllWasteTypesFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getCollectionYardsVisitsDetailFilterValueCached}
          filterUpdateAction={setCollectionYardsVisitsDetailFilter}
        />
      );
    case ColumnType.wasteSum:
    case ColumnType.priceSum:
      return (
        <NumberFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getCollectionYardsVisitsDetailFilterValueCached}
          filterUpdateAction={setCollectionYardsVisitsDetailFilter}
        />
      );
    case ColumnType.paidAt:
      return (
        <BooleanFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getCollectionYardsVisitsDetailFilterValueCached}
          filterUpdateAction={setCollectionYardsVisitsDetailFilter}
        />
      );
    default:
      return <div />;
  }
};

export const CollectionYardsVisitsDetailTableHeaderCell: React.FC<IHeaderCellProps> = ({ params }) => {
  return (
    <TableHeaderCell
      tableName={TABLE_NAME}
      params={params}
      selectorOrdering={getCollectionYardsVisitsDetailOrderingValue}
      selectorFilterIsActive={getCollectionYardsVisitsDetailFilterIsActiveCached}
      removeFilterUpdateAction={removeCollectionYardsVisitsDetailFilter}
      selectFilters={selectFilters}
      orderingUpdateAction={setCollectionYardsVisitsDetailOrdering}
    />
  );
};
